//External Libraries
import { useTranslation } from "react-i18next";

//Hooks
import useEmojiReactions from "../hooks/useEmojiReactions";

//Utils
import { REACTION_ORDER } from "../utils";

//Components
import { CMFlex } from "@chartmetric/chartmetric-design-system/components/CMFlex";
import { CMText } from "@chartmetric/chartmetric-design-system/components/CMText";
import ReactionIconButton from "./ReactionIconButton";

//Types
import type { ReactionType, ReactionCounts } from "../types";

const REACTION_LABEL_KEYS = {
  love: "reactions.love",
  thumbsdown: "reactions.terrible",
} as const;

interface AnnouncementReactionsProps {
  announcementId: number;
  initialReactionCounts?: ReactionCounts;
  initialUserReaction?: ReactionType | null;
  onReactionChange?: () => void;
}

function AnnouncementReactions({
  announcementId,
  initialReactionCounts,
  initialUserReaction,
  onReactionChange,
}: AnnouncementReactionsProps) {
  const { t } = useTranslation("common", { keyPrefix: "announcementPanel" });
  const {
    userReactions: currentUserReactions,
    counts,
    isSubmitting,
    handleReaction,
  } = useEmojiReactions({
    announcementId,
    initialReactionCounts,
    initialUserReaction,
    onReactionChange,
  });

  return (
    <CMFlex vertical mt="md">
      <CMFlex
        align="center"
        r="full"
        px="lg"
        py="sm"
        _className="bg-gradient-to-r from-[#dcfce7] via-[#fef9c3] to-[#fee2e2]"
      >
        {REACTION_ORDER.map((type) => (
          <ReactionIconButton
            key={type}
            type={type}
            count={counts[type] || 0}
            isActive={currentUserReactions.includes(type)}
            isSubmitting={isSubmitting}
            onClick={() => {
              void handleReaction(type);
            }}
          />
        ))}
      </CMFlex>
      <CMFlex justify="between" _className="px-2 mt-1">
        <CMText
          size="xs"
          color="tertiary"
          value={t(REACTION_LABEL_KEYS.love)}
        />
        <CMText
          size="xs"
          color="tertiary"
          value={t(REACTION_LABEL_KEYS.thumbsdown)}
        />
      </CMFlex>
    </CMFlex>
  );
}

export default AnnouncementReactions;
